import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchCurrencyConversionTransaction from '../../../../hooks/useApi/useFetchCurrencyConversionTransaction';
import CurrencyConversionTransactionInfo from './CurrencyConversionTransactionInfo';

type FC = FunctionComponent<vp.TransactionId>;

const CurrencyConversionTransactionContainer: FC = (props: vp.TransactionId) => {
  const { TransactionID } = props;
  const [currencyConversionTransaction, getCurrencyConversionTransaction] = useFetchCurrencyConversionTransaction({});
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.CurrencyConversionTransactionList>();

  useEffect(() => {
    getCurrencyConversionTransaction({
      TransactionID: TransactionID,
    });
  }, [currentTransactionId]);

  useEffect(() => {
    if (currencyConversionTransaction) {
      setTransaction(currencyConversionTransaction.Transactions);
    }
  }, [currencyConversionTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <CurrencyConversionTransactionInfo transaction={transaction} />}</div>;
};

export default CurrencyConversionTransactionContainer;
